var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manage-orders"},[_c('nuxt-link',{staticClass:"text-capitalize",staticStyle:{"color":"#fff"},attrs:{"to":"/order"}},[_c('span',{staticClass:"manage-orders__text"},[_c('span',{staticClass:"manage-orders__text--small"},[_vm._v("Manage")]),_vm._v(" "),_c('span',{staticClass:"manage-orders__text--big"},[_vm._v("Orders")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }